import React, { Component } from "react"
import Link from "gatsby-link"
import PropTypes from "prop-types"
import styled from "styled-components"
import MailchimpForm from "./MailchimpForm"
import { PRIMARY_TEXT, SMALLCHAT_PURPLE } from "../components/consts/colors"

const FooterContainer = styled.footer`
  position: relative;
  padding: 50px 0;
  color: white;
  border-top: 2px solid white;
  background-color: ${PRIMARY_TEXT};
`

const FooterWrapper = styled.div`
  max-width: 1000px;
  margin: 0 auto;
  width: 100%;
  display: flex;
  justify-content: space-between;

  h4 {
    color: rgba(255, 255, 255, 1);
    margin-bottom: 15px;
  }

  p {
    color: rgba(255, 255, 255, 0.8);
  }

  a {
    color: white;
    border-bottom: 1px solid rgba(255, 255, 255, 0.5);
  }

  @media (max-width: 768px) {
    width: 90%;
    flex-direction: column;
    padding-bottom: 100px;
  }

  @media (max-width: 615px) {
    width: 100%;
    flex-direction: column;
    padding-bottom: 100px;
  }
`

const FooterInfo = styled.div`
  width: 360px;
  padding: 20px;
  max-width: 100%;
`

const FooterForm = styled.div`
  width: 520px;
  padding: 20px;
  max-width: 100%;
`

const FooterSocial = styled.ul`
  list-style-type: none;
  padding: 0;
  a {
    color: ${SMALLCHAT_PURPLE};
    margin-right: 20px;
    font-size: 24px;
    border: none;
  }
`

const FooterLinks = styled.div`
  @media (max-width: 768px) {
    position: absolute;
    bottom: 80px;
  }
`

const FooterCopyright = styled.p`
  margin-top: 100px;
  a {
    color: white;
  }
  @media (max-width: 768px) {
    position: absolute;
    bottom: 50px;
  }
`

const Footer = props => {
  return (
    <FooterContainer>
      <FooterWrapper>
        <FooterInfo>
          <h4>Any questions? Let's chat!</h4>
          <p>
            Chat with us using the widget at the bottom-right of the page, or
            shoot us an email at{" "}
            <a href="mailto:support@small.chat">support@small.chat</a>.
          </p>
          <FooterSocial>
            <li>
              <a href="https://twitter.com/smallchatapp">
                <i className="fa fa-twitter" aria-hidden="true" />
              </a>
              <a href="https://stories.nicer.io/">
                <i className="fa fa-medium" aria-hidden="true" />
              </a>
            </li>
          </FooterSocial>
          <FooterLinks>
            <Link to="/terms">Terms of Use</Link>{" "}
            <Link to="/terms#privacy">Privacy Policy</Link>{" "}
            <Link to="/terms#gdpr">GDPR</Link>
          </FooterLinks>
          <FooterCopyright>
            © <a href="http://nicer.io/">Nicer LLC</a>,{" "}
            {new Date().getFullYear()}
          </FooterCopyright>
        </FooterInfo>
        <FooterForm>
          <h4>Sign up for updates!</h4>
          <p>
            We'll send out emails when we add new features
            <br />
            or schedule maintenance.
          </p>
          <MailchimpForm />
        </FooterForm>
      </FooterWrapper>
    </FooterContainer>
  )
}

export default Footer



// WEBPACK FOOTER //
// ./src/layouts/Footer.js